import { DirectoryValue } from "@/modules/api/directory-value.model";

export default class PlushieImageType extends DirectoryValue {
  public static readonly MAIN = "1";
  public static readonly ADDITIONAL = "2";
}
